module.exports = __webpack_public_path__ + "img/11.8a4e2f55.jpg";